"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RleEncodedStreamMetadata = void 0;
const DecodingUtils_1 = require("../../decoder/DecodingUtils");
const StreamMetadata_1 = require("./StreamMetadata");
class RleEncodedStreamMetadata extends StreamMetadata_1.StreamMetadata {
    constructor(physicalStreamType, logicalStreamType, logicalLevelTechnique1, logicalLevelTechnique2, physicalLevelTechnique, numValues, byteLength, runs, numRleValues) {
        super(physicalStreamType, logicalStreamType, logicalLevelTechnique1, logicalLevelTechnique2, physicalLevelTechnique, numValues, byteLength);
        this.runCount = runs;
        this.num_rle_values = numRleValues;
    }
    static decode(tile, offset) {
        const streamMetadata = StreamMetadata_1.StreamMetadata.decode(tile, offset);
        const rleInfo = DecodingUtils_1.DecodingUtils.decodeVarint(tile, offset, 2);
        return new RleEncodedStreamMetadata(streamMetadata.physicalStreamType(), streamMetadata.logicalStreamType(), streamMetadata.logicalLevelTechnique1(), streamMetadata.logicalLevelTechnique2(), streamMetadata.physicalLevelTechnique(), streamMetadata.numValues(), streamMetadata.byteLength(), rleInfo[0], rleInfo[1]);
    }
    static decodePartial(streamMetadata, tile, offset) {
        const rleInfo = DecodingUtils_1.DecodingUtils.decodeVarint(tile, offset, 2);
        return new RleEncodedStreamMetadata(streamMetadata.physicalStreamType(), streamMetadata.logicalStreamType(), streamMetadata.logicalLevelTechnique1(), streamMetadata.logicalLevelTechnique2(), streamMetadata.physicalLevelTechnique(), streamMetadata.numValues(), streamMetadata.byteLength(), rleInfo[0], rleInfo[1]);
    }
    runs() {
        return this.runCount;
    }
    numRleValues() {
        return this.num_rle_values;
    }
}
exports.RleEncodedStreamMetadata = RleEncodedStreamMetadata;
//# sourceMappingURL=RleEncodedStreamMetadata.js.map